import * as yup from "yup";

const urlValidator =
  process.env.NODE_ENV === "production" ? yup.string().url() : yup.string();

const envSchema: yup.ObjectSchema<EnvSchema> = yup.object().shape({
  SIDEKICK_API_URL: urlValidator.required(),
  RADAR_BRAND_API_URL: urlValidator.required(),
  CRM_API_URL: urlValidator.required(),
  RADAR_API_URL: urlValidator.required(),
  SIDEKICK_COMPS_API_URL: urlValidator.required(),
  STRIPE_PUBLISHABLE_KEY: yup.string().required(),
  NODE_ENV: yup
    .string()
    .oneOf(["development", "production", "test"])
    .required(),
  APP_ENV: yup
    .string()
    .oneOf(["development", "staging", "production"])
    .required(),
  DATADOG_APPLICATION_ID: yup.string().optional().nullable(),
  DATADOG_CLIENT_TOKEN: yup.string().optional().nullable(),
  HIDE_ALL_APP_EVENTS: yup.boolean().optional().nullable(),
  SIDEKICK_DEV_TOOLS_ENABLED: yup.boolean().optional().nullable(),
  REACT_QUERY_DEV_TOOLS_ENABLED: yup.boolean().optional().nullable(),
  SIDEKICK_MSW_ENABLED: yup.boolean().optional().nullable(),
  INTERCOM_APP_ID: yup.string().optional().nullable(),
  COMMIT_SHA: yup.string().optional().nullable(),
  GOOGLE_MAPS_API_KEY: yup.string().required(),
  TINYMCE_API_KEY: yup.string().required(),
  SIDEKICK_SMS_CHAT_NUMBER: yup.string().optional().nullable(),
  PROPERTY_SEARCH_API_URL: urlValidator.required(),
  POSTHOG_API_KEY: yup.string().optional().nullable(),
});

type EnvSchema = {
  SIDEKICK_API_URL: string;
  RADAR_BRAND_API_URL: string;
  CRM_API_URL: string;
  RADAR_API_URL: string;
  SIDEKICK_COMPS_API_URL: string;
  STRIPE_PUBLISHABLE_KEY: string;
  NODE_ENV: "development" | "production" | "test";
  APP_ENV: "development" | "staging" | "production";
  DATADOG_APPLICATION_ID?: string | null;
  DATADOG_CLIENT_TOKEN?: string | null;
  HIDE_ALL_APP_EVENTS?: boolean | null;
  SIDEKICK_DEV_TOOLS_ENABLED?: boolean | null;
  REACT_QUERY_DEV_TOOLS_ENABLED?: boolean | null;
  SIDEKICK_MSW_ENABLED?: boolean | null;
  INTERCOM_APP_ID?: string | null;
  COMMIT_SHA?: string | null;
  GOOGLE_MAPS_API_KEY: string;
  TINYMCE_API_KEY: string;
  SIDEKICK_SMS_CHAT_NUMBER?: string | null;
  PROPERTY_SEARCH_API_URL: string;
  POSTHOG_API_KEY?: string | null;
};

const getNullableValue = <T>(value: T | null | undefined): T | null => {
  if (value == null || value == undefined || value === "null") return null;
  return value;
};

export const appConfig: EnvSchema = (() => {
  try {
    return envSchema.validateSync({
      SIDEKICK_API_URL: process.env.SIDEKICK_API_URL ?? "",
      RADAR_BRAND_API_URL: process.env.RADAR_BRAND_API_URL ?? "",
      CRM_API_URL: process.env.CRM_API_URL ?? "",
      RADAR_API_URL: process.env.RADAR_API_URL ?? "",
      SIDEKICK_COMPS_API_URL: process.env.SIDEKICK_COMPS_API_URL ?? "",
      STRIPE_PUBLISHABLE_KEY: process.env.STRIPE_PUBLISHABLE_KEY ?? "",
      NODE_ENV: process.env.NODE_ENV,
      APP_ENV: process.env.APP_ENV,
      DATADOG_APPLICATION_ID: getNullableValue(
        process.env.DATADOG_APPLICATION_ID,
      ),
      DATADOG_CLIENT_TOKEN: getNullableValue(process.env.DATADOG_CLIENT_TOKEN),
      HIDE_ALL_APP_EVENTS: process.env.HIDE_ALL_APP_EVENTS,
      SIDEKICK_DEV_TOOLS_ENABLED: process.env.SIDEKICK_DEV_TOOLS_ENABLED,
      REACT_QUERY_DEV_TOOLS_ENABLED: process.env.REACT_QUERY_DEV_TOOLS_ENABLED,
      SIDEKICK_MSW_ENABLED: process.env.SIDEKICK_MSW_ENABLED,
      INTERCOM_APP_ID: getNullableValue(process.env.INTERCOM_APP_ID),
      COMMIT_SHA: getNullableValue(process.env.COMMIT_SHA),
      GOOGLE_MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY ?? "",
      TINYMCE_API_KEY: process.env.TINYMCE_API_KEY ?? "",
      SIDEKICK_SMS_CHAT_NUMBER: getNullableValue(
        process.env.SIDEKICK_SMS_CHAT_NUMBER,
      ),
      PROPERTY_SEARCH_API_URL: process.env.PROPERTY_SEARCH_API_URL ?? "",
      POSTHOG_API_KEY: getNullableValue(process.env.POSTHOG_API_KEY),
    });
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      throw new Error(`Validation error: ${error.message}`);
    } else {
      throw new Error(`An unexpected error occurred: ${error}`);
    }
  }
})();
